import { PaginatorPageChangeEvent } from "primereact/paginator";
import { BASE_URL, RECORD_PER_PAGE } from "./constants";
import { AuthType, PaginatedResponse, Pagination } from "./types";

export const refreshTokens = async (token: string, target: AuthType) => {
	const response = await fetch(`${BASE_URL}/auth/${target}/refresh`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		method: 'POST',
	});
	if (response.status === 401 || response.status === 400) {
		throw new Error();
	} else {
		return await response.json();
	}
};




export const getPaginationOptions = (responseData: PaginatedResponse<any>, setPage: Function): Pagination => {
	return {
		first: +responseData?.currentPage,
		totalRecords: responseData?.totalItems,
		rowsPerPageOption: [RECORD_PER_PAGE],
		totalPages: responseData?.totalPages,
		onPageChange: (e: PaginatorPageChangeEvent) => {
			setPage(e.page + 1);
		},
	};
};



export const handleGlobalSearch = (filters: any, keys: string[]) => {
	const baseFilter = Object.fromEntries(
		Object.keys(filters)
			.map((key) => [key, filters[key].value])
			.filter((item) => item[1]),
	);
	let newFilter = {};
	if (baseFilter.global) newFilter = Object.fromEntries(keys.map((key) => [key, baseFilter?.global]));
	delete baseFilter['global'];
	return { ...newFilter, ...baseFilter };
};



const getDateTimeFormatOption = (): Intl.DateTimeFormatOptions => ({
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: 'numeric',
	minute: 'numeric',
	hour12: true,
});


const getDateFormatOption = (): Intl.DateTimeFormatOptions => ({
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',

});

export const formatDateTime = (date: string | Date) => {
	if (!date) return ''
	return new Intl.DateTimeFormat('en-GB', getDateTimeFormatOption()).format(new Date(date));
};


export const formatDate = (date: string | Date) => {
	if (!date) return ''
	return new Intl.DateTimeFormat('en-GB', getDateFormatOption()).format(new Date(date));
};



export const mapTreatmentCourseFilters = (filters: any) => {
	const filtersClone = { ...filters }
	if (filtersClone.patientName) {
		filtersClone.name = filtersClone.patientName
		delete filtersClone.patientName
	}

	if (filtersClone.patientId) {
		filtersClone.nationalId = filtersClone.patientId
		delete filtersClone.patientId
	}
	return filtersClone
}